import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowLeft_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.7071 6.29289C19.0976 6.68342 19.0976 7.31658 18.7071 7.70711L7.41421 19H35C35.5523 19 36 19.4477 36 20C36 20.5523 35.5523 21 35 21H7.41421L18.7071 32.2929C19.0976 32.6834 19.0976 33.3166 18.7071 33.7071C18.3166 34.0976 17.6834 34.0976 17.2929 33.7071L4.29289 20.7071C3.90237 20.3166 3.90237 19.6834 4.29289 19.2929L17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289Z"
            />
        </SvgStyled>
    );
};

export default ArrowLeft_xl;
